export const BILLING_MAINTENANCE_STREAM_PATH = 'stream';

export const BILLING_MAINTENANCE_SSE_EVENT = 'maintenance_status';

export const BILLING_MAINTENANCE_UPDATE_EVENT = 'billing-maintenance__update';
